import { type CSSObject, inputLabelClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { typographyOverrides } from '@Material/typography'

export const overridesInputLabel = (theme: Theme): ComponentsOverrides['MuiInputLabel'] => ({
  root: {
    ...(typographyOverrides(theme)?.body2 as CSSObject),
    [`&.${inputLabelClasses.error}`]: {
      color: theme.palette.text.primary,
    },
    color: theme.palette.text.secondary,
  },
  outlined: {
    transform: `translate(${theme.spacing(2)}, ${rem(18)}) scale(1)`,
    [`&.${inputLabelClasses.shrink}`]: {
      transform: `translate(${theme.spacing(2)}, -6px) scale(0.75)`,
      [`&:not(.${inputLabelClasses.disabled})`]: {
        color: theme.palette.text.primary,
      },
    },
  },
})
